import { render, staticRenderFns } from "./FacetsHeader.vue?vue&type=template&id=c23250ea&"
import script from "./FacetsHeader.vue?vue&type=script&lang=js&"
export * from "./FacetsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports